import React from "react";
import { useDroppable } from "@dnd-kit/core";
import {
    SortableContext,
    verticalListSortingStrategy
} from "@dnd-kit/sortable";

import SortableItem from "./SortableItem";
import { Col, Row } from "antd";

const containerStyle = {
    // if(type === "component"){
    //     border:"dashed",
    // }
    // else{
    // border:"none",

    // }
    // background: "#dadada",
    border:"dashed",
    // padding: 10,
    // margin: 10,
    // flex: 1
};

const Container = (props) => {

    // export default function Container(props) {
    const { id, items, type } = props;

    const { setNodeRef } = useDroppable({
        id
    });

    return (
        <Col span={24}>
            <SortableContext
                id={id}
                items={items}
                strategy={verticalListSortingStrategy}
            >
                <Row gutter={[10, 20]} 
                justify="space-around" 
                ref={setNodeRef} 
                style={containerStyle}
                >
                    {items.map((component) => (
                        // <Col>
                            <SortableItem key={id} type={type} id={component.component_id} name={component.component_name} />
                        //  </Col>
                    ))}
                </Row>
            </SortableContext>
        </Col>
    );
}
export default Container;
